export class NavigationOptions {

    constructor(
        public label: string, 
        public imageSource: string, 
        public alt: string, 
        public route: string, 
        public description?: string) { }

}